const OfferStatusEnum = Object.freeze({
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    EVERGREEN: 'EVERGREEN',
    COMING_SOON: 'COMING_SOON'
});

export default OfferStatusEnum;
